/**
 * Vibration utility - uses Capacitor Haptics when native, falls back to Web Vibration API
 */

import { haptics, isNative } from '../lib/native';

/**
 * Light tap feedback
 */
export const vibrateTap = () => {
  if (isNative) {
    haptics.impact('Light');
  } else if (navigator.vibrate) {
    navigator.vibrate(10);
  }
};

/**
 * Medium vibration - for actions like start/pause
 */
export const vibrateMedium = () => {
  if (isNative) {
    haptics.impact('Medium');
  } else if (navigator.vibrate) {
    navigator.vibrate(50);
  }
};

/**
 * Strong vibration - for milestones like reaching 1km
 */
export const vibrateStrong = () => {
  if (isNative) {
    haptics.impact('Heavy');
  } else if (navigator.vibrate) {
    navigator.vibrate([100, 50, 100]);
  }
};

/**
 * Success pattern - double vibration for achievements
 */
export const vibrateSuccess = () => {
  if (isNative) {
    haptics.notification('Success');
  } else if (navigator.vibrate) {
    navigator.vibrate([50, 100, 50, 100, 100]);
  }
};

/**
 * Milestone vibration - for reaching each kilometer
 */
export const vibrateMilestone = () => {
  if (isNative) {
    haptics.notification('Success');
  } else if (navigator.vibrate) {
    navigator.vibrate([100, 80, 100, 80, 200]);
  }
};

/**
 * Light continuous vibration for hold-to-stop
 * Returns a function to stop the vibration
 */
export const vibrateHoldStart = () => {
  if (isNative) {
    const interval = setInterval(() => {
      haptics.impact('Light');
    }, 100);
    return () => clearInterval(interval);
  } else if (navigator.vibrate) {
    const pattern = [];
    for (let i = 0; i < 30; i++) {
      pattern.push(30, 70);
    }
    navigator.vibrate(pattern);
    return () => navigator.vibrate(0);
  }
  return () => {};
};

/**
 * Stop any ongoing vibration
 */
export const vibrateStop = () => {
  if (navigator.vibrate) {
    navigator.vibrate(0);
  }
};

/**
 * Small notification vibration (for banners)
 */
export const vibrateNotification = () => {
  if (isNative) {
    haptics.impact('Light');
  } else if (navigator.vibrate) {
    navigator.vibrate(30);
  }
};
